import PropTypes from 'prop-types'
import NoneAnchor from 'components/NoneAnchor'

export const getSiteText = (protocol, url) =>
  `${protocol.toLowerCase()}://${url}`

export const SiteText = ({ siteUrl }) => {
  const { protocol, url } = siteUrl
  return getSiteText(protocol, url)
}
SiteText.propTypes = {
  siteUrl: PropTypes.shape({
    protocol: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
}

const SiteUrlLink = ({ siteUrl, clickable = true }) => {
  const { protocol, url } = siteUrl
  const link = getSiteText(protocol, url)
  return clickable ? (
    <a
      href={link}
      className="link_txt"
      target="_blank"
      rel="noopener noreferrer">
      {link}
    </a>
  ) : (
    <NoneAnchor className="link_txt">{link}</NoneAnchor>
  )
}
SiteUrlLink.propTypes = {
  siteUrl: PropTypes.shape({
    protocol: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  clickable: PropTypes.bool,
}
export default SiteUrlLink
